/* eslint-disable no-undef */
/* eslint-disable radix */
/* eslint-disable no-new */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable func-names */

import { default as SettingsMenu } from '../OMT_UI/Menus/Settings/OMT_UI_SettingsMenu';
import TutorialNewGingy from '../Elements/GingyTutorial/G.TutorialNewGingy';
import LevelEconomyTracker from '../Elements/GameTracking/LevelEconomyTracker';
import { FadeLayer } from '../Elements/FadeLayer';
import { XPROMO_PLACEMENTS } from '../Services/OMT/OMT_CrossPromo';
import LevelBg from '../Elements/GameState/UI/Layers/LevelBg';
import LvlObject from '../Elements/GameState/Managers/LvlObject';
import StartBoosterConfig from '../Elements/StartBoosterConfig';
import { LevelType, TreasureChestTypes } from '../Elements/GameState/Managers/GameEnums';
import PerLevelData from '../Elements/Leaderboard/PerLevelData';
import CollectableAnimLayer from '../Elements/GameState/CollectableAnim/CollectableAnimLayer';
import { UI_RequestHelpForMoves } from '../Elements/GameState/UI/UI_RequestHelpForMoves';
import UI_ShoutOuts from '../Elements/GameState/UI/UI_ShoutOut';
import PointsLayer from '../Elements/GameState/UI/Layers/PointsLayer';
import Overlay from '../Elements/GameState/UI/Layers/Overlay1';
import Overlay2 from '../Elements/GameState/UI/Layers/Overlay2';
import UI_BoosterPanel from '../Elements/GameState/UI/UI_BoosterPanel';
import UITargetParticles from '../Elements/G.UITargetParticles';
import UI_TopBar from '../Elements/GameState/UI/TopBar/UI_TopBar';
import LevelNumberTab from '../Elements/GameState/UI/TopBar/LevelNumberTab';
import ChestLayer from '../Elements/GameState/UI/Layers/ChestLayer';
import UIFxLayer from '../Elements/GameState/UI/Layers/UIFxLayer';
import TopFxLayer from '../Elements/GameState/UI/Layers/TopFxLayer';

/**
 * Welcome to the game state where a lot of the fun happens!
 * A lot of global variable accessing happens and its hard to know what is what, but here's quick list:
 *
 * state = game.js
 * game.state.getCurrentState() = game.js (unless on world map)
 * this.state = game.js (unless on world map)
 * G.lvl = this._gameplayController
 */
export default class Game {
    /**
     * Required by Phaser
     * This is the very first thing that gets called when the state starts.
     * Called before preload or create
     * @param {Object} config
     * @param {number} config.lvlIndex
     * @param {boolean} [config.debugMode]
     * @param {Object || Array<number>} [config.startBoosters]
     * @param {Array<number>} [config.startBoosters.player] = Regular preboosters
     * @param {Array<number>} [config.startBoosters.requestHelp] = Request help preboosters
     * @param {Object} [config.challengeLvl]
     * @param {Object} [config.preLevelTrackingData]
     */
    init(config) {
        // Set up variable so that game.js can be accessed from literally anywhere.
        window.s = game.state.getCurrentState(); // IT IS this.
        this.state = s; // ALSO this.

        this._removedLifeAtStart = false;
        this._config = config;

        // Fill start boosters
        this._assembleStartBoosters();

        // added stateInitCount to verify if delayed events happen in the correct scene + initialization
        if (!this.stateInitCount) this.stateInitCount = 0;
        this.stateInitCount++;

        // Getting level data
        this._collectLevelData();
        this._setDebugMode(this._config.debugMode);

        this._signalBindings = []; // For collecting signals to dispose of later

        // Initialize DDNA mission tracker. To be used in create()
        this._preLevelTrackingData = this._config.preLevelTrackingData;
        this._createGameSessionData();
        //this._trackDDNAOnInit();
        sdkHandler.trigger('levelStart', { 
            level: this.lvlIndex + 1
        },this);
    }

    /**
     * Required by Phaser. Preload is called after init
     */
    preload() {
        G.Helpers.loadShoutouts(OMT.language.lang);
    }

    /**
     * Required by Phaser. Create is immediately called after preload is finished
     */
    create() {
        const showLevelAsHard = this.lvlData && this.lvlData.showAsHard; // Hard level?
        this._trackGameplayFlags();

        // Initialize Gameplay controller and G.lvl
        this._createGameplayController();

        // Background
        this._bg = new LevelBg(showLevelAsHard ? 'background_2' : 'background_1');

        // Board
        this._createBoard();

        // Top bar
        this.topBar = new UI_TopBar(this._gameplayController, this.lvlData); // Accessed outside

        // The number tab
        this._createNumberTab(showLevelAsHard);

        // Creates the booster panel and the booster buttons
        this.boosterPanel = new UI_BoosterPanel(this.board);

        // Initialize the DDNA mission tracker
        //this._createDDNATrackingOnCreate();
        LevelEconomyTracker.getInstance().onLevelStarted(this.lvlIndex);

        // Overlay 2 layer
        this._createOverlay2();

        // Create the settings menu
        this._createSettingsMenu();

        // Collectable animation layer for gems breaking
        this.collectableAnimLayer = new CollectableAnimLayer(this.board, this.topBar.goalPanel);

        // Chest layer for the game board
        this._createChestLayer();

        // SFX Layers
        this._createSFXLayers();

        // Points
        this.pointsLayer = new PointsLayer(this.topBar.pointsCounter);

        // The Request Help 2.0
        // if (OMT.feature.getFeatureRequestMoveHelp()) {
        //   this.movesHelper = new UI_RequestHelpForMoves(game, this._gameplayController, this);
        // }

        // Shoutout layer
        this.shoutOuts = new UI_ShoutOuts(this);

        // Overlay 1 layer. For tutorials and boosters
        this.overlay = new Overlay(this); // Accessed externally

        // Window manager for when windows pop up in the board
        this._createWindowManager();

        // Check the events that will alter the board. Such as fortune cookie or mystery gift
        this._checkEventsOnBoard();

        // Particle layers
        this.uiTargetParticles = new UITargetParticles();
        G.fadeLayer = new FadeLayer();

        // Check for tutorial
        this._checkTutorials();

        // Inits debug tools if in debug mode
        this.debugInit();

        game.resizeGame();

        // set the image smoothing quality to high
        game.canvas.getContext("2d").imageSmoothingQuality = "high";
    }

    /**
     * Update
     */
    update() {
        G.delta();
        if (G.DEBUG) {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
        }
    }

    /**
     * Shutdown is called when the state is closed.
     * Don't forget to clean up signal bindings!
     */
    shutdown() {
        if (this._signalBindings) {
            this._signalBindings.forEach((binding) => {
                if (binding.detach) {
                    binding.detach();
                }
            });
            this._signalBindings = null;
        }
        delete G.saveState.sessionData.mysteryGift;
        this._gameplayController.destroy();
        this._chestLayer.destroy();
        this.shoutOuts.destroy();
        this._bg.destroy();
        this.boosterPanel.destroy();
        this.pointsLayer.destroy();
        if (this.movesHelper) {
            this.movesHelper.destroy();
        }
        this.overlay.destroy();
        this.topBar.destroy();
        this._overlayUnderSettings.destroy();
        this.fxTopLayer.destroy();
        this.UIFxLayer.destroy();
        this._gameplayController.destroy();
        if (this.movesHelper) {
            this.movesHelper.destroy();
        }
        this.treasureHuntGemCounter = null;
        this.treasureHuntGingyFail = null;
        this._perLevelData = null;
    }

    /**
     * Finds out level data and sets up references
     */
    _collectLevelData() {
        if (this._config.challengeLvl) {
            this.lvlIndex = 10000 + (G.saveState.data.dailyBeaten || 0);
            this.lvlData = this._config.challengeLvl;
            this.mode = LevelType.CHALLENGE;
        } else {
            this.lvlIndex = Math.min(G.Helpers.levelDataMgr.getMaxLevelIndex(), this._config.lvlIndex);
            this.lvlData = G.Helpers.levelDataMgr.getLevelByIndex(this.lvlIndex);
            this.mode = LevelType.NORMAL;
        }
        G.gameMode = this.mode; // added to be able to easily track the game mode
        G.lvlData = this.lvlData;
    }

    /**
     * Imports the data from the config to the StartBoosterConfig
     */
    _assembleStartBoosters() {
        this.startBoosterConfig = new StartBoosterConfig(); // Accessed externally
        if (this._config.startBoosters) {
            this.startBoosterConfig.importData(this._config.startBoosters.player, null, this._config.startBoosters.requestHelp);
        }
        this.startBoosters = this._config.startBoosters || []; // Access externally
    }

    /**
     * Create object data to be used to keep track of things in the game board
     * The session data should always refresh when the game board refreshes
     */
    _createGameSessionData() {
        // Created in game.js init(), deleted in game.js shutdown()
        G.saveState.sessionData.mysteryGift = {
            mysteryGiftMode: false,
            mysteryGiftModePeak: false,
            mysteryBoostersInitialized: false,
        };
    }

    /**
     * Track last level attempted by the player and reset player rewards
     */
    _trackDDNAOnInit() {
        if (DDNA.tracking.enabled) {
            // send any previous incomplete level rewards
            DDNA.transactionHelper.sendQueuedLevelCoinRewards();
            DDNA.transactionHelper.resetQueuedLevelRewards();
            DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('lastLevelAttempted', this.mode === LevelType.CHALLENGE ? -1 : this.lvlData.levelNumber, true);
        }
    }

    /**
     * Debug on or off
     * @param {boolean} dbg
     */
    _setDebugMode(dbg) {
        this._debugMode = dbg || false;
        G.debugMode = this._debugMode;
    }

    /**
     * This tracks various flags like lose a life, mystery gift, high score
     */
    _trackGameplayFlags() {
        if (G.PERLEVELHIGHSCORE) { // Get a level data object going
            this._perLevelData = new PerLevelData(this._config.lvlIndex + 1);
        }
        if (G.MYSTERYGIFT) G.saveState.mysteryGift_markLevelBeggining(); // Mark mystery gift
        G.saveState.onLevelRetry(this.lvlIndex); // Record level attempts

        // Lose life to prevent cheating
        if (this.mode === LevelType.NORMAL && G.saveState.getUnlimitedLivesSec() === 0) {
            G.saveState.loseLife();
            this._removedLifeAtStart = true;
        }
    }

    /**
     * Initialize the gameplay controller.
     * Also known has the fearful
     * G.lvl
     */
    _createGameplayController() {
        this._gameplayController = new LvlObject(this.lvlIndex, this.lvlData);
        G.lvl = this._gameplayController; // REFACTOR: left for compability // 10/03/20 SK: At this point G.lvl is too far gone...
        G.lvlNr = this._gameplayController.lvlIndex;
    }

    /**
     * Create the great lord and mighty
     * B O A R D
     */
    _createBoard() {
        this.board = new G.Board(this.lvlData, G.l(72));
        this.board.onBoardDeconstructed.add(this._onBoardDeconstructed, this);
        this.board.onActionQueueEmpty.add(this._onActionQueueEmpty, this);
    }

    /**
     * Create the number tab that shows up on the top of the top bar
     * @param {boolean} showLevelAsHard
     */
    _createNumberTab(showLevelAsHard) {
        const getLevelNumberToDisplay = (lvlIndex) => {
            if (lvlIndex >= 10000) return null;
            return lvlIndex + 1;
        };
        const levelIndexToDisplay = getLevelNumberToDisplay(this.lvlIndex);
        if (levelIndexToDisplay !== null) {
            // Made with JSON UI...
            const levelNumberTab = new LevelNumberTab(game, game.world, G.l(640), G.l(960), showLevelAsHard, levelIndexToDisplay);
            this._signalBindings.push(G.sb('onScreenResize').add(() => { levelNumberTab.resize(G.l(640), G.l(960)); }));
            this._signalBindings.push(G.sb('onAllWindowsClosed').addOnce(levelNumberTab.animateSlideIn, levelNumberTab));
        }
    }

    /**
     * Create and initializes the DDNA mission tracker
     * Also tracks data
     */
    _createDDNATrackingOnCreate() {
        const extraData = {};
        if (this._preLevelTrackingData) {
            Object.assign(extraData, this._preLevelTrackingData);
        }
        DDNA.missionTracker.init(this.mode, extraData);
        DDNA.tracking.getDataCapture().addToPlayerCharacterizationSessionParam('levelAttemptsThisSession', 1);

        OMT.platformTracking.logEvent(this.mode === LevelType.CHALLENGE ? 'level_start_dc' : 'level_start');

        // Begin tracking
        LevelEconomyTracker.getInstance().onLevelStarted(this.lvlIndex);
        DDNA.tracking.ftuxEvent(3, 'gameFieldIsVisible');
        OMT.platformTracking.logFTUEvent('FTUGameFieldIsVisible');

        if (this.lvlIndex === 1) {
            DDNA.tracking.ftuxEvent(7, 'secondLevelStart');
        } else if (this.lvlIndex === 2) {
            DDNA.tracking.ftuxEvent(10, 'thirdLevelStart');
        } else if (this.lvlIndex === 3) {
            DDNA.tracking.ftuxEvent(14, 'fourthLevelStart');
        } else if (this.lvlIndex === 10) {
            DDNA.tracking.ftuxEvent(18, 'eleventhLevelStart');
        }
    }

    /**
     * Creates an Overlay2.
     * Its slightly different from Overlay1 which is for the tutorials
     */
    _createOverlay2() {
        this._overlayUnderSettings = new Overlay2(true, 0.4);
        this._overlayUnderSettings.pointerUpSignal.add(
            function() { this.settingsMenu.expandedState = false; },
            this,
        );
    }

    _createSettingsMenu() {
        this.settingsMenu = new SettingsMenu(); // Accessed externally
        // on screen resized
        const onScreenResize = () => {
            this.settingsMenu.x = 74;
            this.settingsMenu.y = game.height - 65;
        };
        // on menu expanded
        this.settingsMenu.signals.onExpand.add(() => {
            this._overlayUnderSettings.showOverlay();
            this.boosterPanel.animatePositionToHidden();
        });
        // on menu contracted
        this.settingsMenu.signals.onContract.add(() => {
            this._overlayUnderSettings.hideOverlay();
            this.boosterPanel.animatePositionToVisible();
        });

        game.world.addChild(this.settingsMenu);
        onScreenResize();
        this._signalBindings.push(G.sb('onScreenResize').add(onScreenResize));
    }

    /**
     * Creates the chest layer that animates the chest on the board
     */
    _createChestLayer() {
        this._chestLayer = new ChestLayer(this);
        this._chestLayer.onChestGiftShown.add(this.onChestGiftShown, this);
    }

    /**
     * Creates SFX layers for the UI and the board
     */
    _createSFXLayers() {
        // User Interface FX layer (primarily used for start boosters). Accessed externally
        this.UIFxLayer = new UIFxLayer(this.board);

        // Board fx layer
        this.fxTopLayer = new TopFxLayer(this.board, 'fxTop');
        this.fxTopLayer.position = this.board.boardCandies.position;
        this.fxTopLayer.scale = this.board.boardCandies.scale;
    }

    /**
     * Creates the window manager so windows can be shown
     */
    _createWindowManager() {
        this.windowMgr = new G.WindowMgr();
        this.windowMgr.addLayerToWorld('base');
        this.windowMgr.addLayerToWorld('retryLevel', { offset: { x: 0, y: G.WindowMgr.Constants.WorldVerticalOffset } }); // For the retry level popup when you fail the mission only
        this.windowMgr.addLayerToWorld(G.WindowMgr.LayerNames.OverlayLayer);
    }

    /**
     * Checks for any events that should happen before the game board starts
     */
    _checkEventsOnBoard() {
        this._checkFortuneCookie();
        // Sets up treasure hunt if active
        if (G.TreasureHunt.treasureHuntMgr.isLevelTreasureHuntActive(this._gameplayController.lvlIndex)) {
            this.setupTreasureHunt(this.lvlIndex);
        }
        this._checkMysteryGift();
        this._checkHelpers();
    }

    /**
     * If this is a new user and they've launched the game from a shared fortune cookie msg
     */
    _checkFortuneCookie() {
        if (G.showFortuneCookie) {
            G.sb('pushWindow').dispatch(['fortuneCookie', {
                playOpenAnim: true,
                hideNotNow: true,
            }]);
            G.showFortuneCookie = false;
        }
    }

    /**
     * Gives user feedback that mystery gift is active
     */
    _checkMysteryGift() {
        // Keep winning to have more mystery gifts!
        if (G.MYSTERYGIFT && G.saveState.mysteryGift_isModeReady()) {
            if (G.saveState.mysteryGift_getCurrentStreak() < 3 &&
                this._gameplayController.latestLevel) {
                // allow to increase mysteryGift
                G.saveState.sessionData.mysteryGift.mysteryGiftModePeak = true;
                this.windowMgr.pushWindow('mysteryGiftLevel');
            }
        }
        this.windowMgr.pushWindow('taskSlider');
    }

    /**
     * Checks if Helpers 2.0 is active
     */
    _checkHelpers() {
        if (!G.saveState.sessionData.levelsFailedSinceUsingHelper) G.saveState.sessionData.levelsFailedSinceUsingHelper = {};
    }

    /**
     * Checks if a tutorial is in the level.
     * Also checks for popup tutorials after
     */
    _checkTutorials() {
        if (this.lvlData.tutID &&
            G.json.tutorials[this.lvlData.tutID] &&
            G.saveState.data.finishedTutorials.indexOf(this.lvlData.tutID) === -1) {
            this._signalBindings.push(G.sb('onAllWindowsClosed').addOnce(() => {
                if (G.json.tutorials[this.lvlData.tutID].steps) {
                    // this.tut = new G.TutorialMulti(this.lvlData.tutID);
                    this.tut = new TutorialNewGingy(this.lvlData.tutID);
                } else {
                    this.tut = new G.Tutorial(this.lvlData.tutID);
                }
            }, this));

            this._signalBindings.push(G.sb('onTutorialFinish').addOnce(() => {
                if (this.board.actionManager.actionList.length === 0) {
                    this.board.actionManager.newAction('startBoosterInit');
                } else {
                    this._signalBindings.push(G.sb('actionQueueEmpty').addOnce(() => {
                        this.board.actionManager.newAction('startBoosterInit');
                    }, this));
                }
            }, this));
            this._signalBindings.push(G.sb('onTutorialFinishDisplay').addOnce(() => {
                if (G.MYSTERYGIFT && G.saveState.mysteryGift_isModeReady()) {
                    new G.MysteryGiftHeaderInGame(this._gameplayController.latestLevel);
                }
                this.handleLastLifeNotification();
            }, this));
        } else {
            this._signalBindings.push(G.sb('onAllWindowsClosed').addOnce(() => {
                this.board.actionManager.newAction('startBoosterInit');
                if (G.MYSTERYGIFT && G.saveState.mysteryGift_isModeReady()) {
                    new G.MysteryGiftHeaderInGame(this._gameplayController.latestLevel);
                }
                this.handleLastLifeNotification();
            }, this));
        }

        // Check for pop up tutorials after that
        G.checkPopUpTutorials(this);
    }

    /**
     * Handles the last life notification to make you feel like your life is on the line!
     */
    handleLastLifeNotification() {
        if (G.saveState.getLives() !== 0) return;

        G.NotificationsMgr.pushNotification(
            OMT.language.getText('This is your last life! Try your best!'),
            'broken_heart',
            2500,
        );
    }

    /**
     * End of level, check if we can show ads
     * @param {function} callback
     */
    endPointCheckForAds(callback) {
        if (!G.saveState.sessionData.tryNumber) G.saveState.sessionData.tryNumber = 0;
        let showAd = false;

        if (G.saveState.getLastPassedLevelNr() >= G.featureUnlock.unlockLevels.interstitialAds) {
            if (G.saveState.sessionData.tryNumber % G.json.settings.interstitialSettings.everyN === 0) showAd = true;
            G.saveState.sessionData.tryNumber++;
        }

        if (showAd) {

        }
        // if (showAd && G.saveState.getIAPCount() === 0) {
        //   if (OMT.crossPromo.isPlacementActive(XPROMO_PLACEMENTS.INTERSTITIAL) && !OMT.crossPromo.isCrossPromoSeen()) {
        //     const crossPromoData = OMT.crossPromo.getPromoByPlacementId(XPROMO_PLACEMENTS.ICON_PICTURE_COMBO); // TODO: update placement id
        //     OMT.crossPromo.showCrossPromoWindow('interstitial', crossPromoData, callback);
        //     console.log('** end point showCrossPromoAd');
        //   } else if (OMT.feature.interstitialAdsAvailable()) {
        //     console.log('** end point showAd');
        //     let placement;
        //     switch (G.PerSessionSettings.interstitialsInSession) {
        //       case 0:
        //         placement = G.BuildEnvironment.adPlacements.firstInterstitialInSession;
        //         break;
        //       case 1:
        //         placement = G.BuildEnvironment.adPlacements.secondInterstitialInSession;
        //         break;
        //       default:
        //         placement = G.BuildEnvironment.adPlacements.interstitial;
        //     }

        //     G.PerSessionSettings.interstitialsInSession++;

        //     // needed to ad the ad shown event on success
        //     const successCallback = () => {
        //       callback();
        //     };

        //     OMT.ads.showAd(placement, successCallback, callback);
        //   }
        // } else {
        //   console.log('** end point dont showAd');
        //   callback();
        // }
    }

    /**
     * When the board is done. Usually when the goal is achieved, this is called
     * Or through cheating s._onBoardDeconstructed
     */
    async _onBoardDeconstructed() {
        // imports
        const { treasureHuntMgr } = G.TreasureHunt;

        const configForPopUp = {
            lvlIndex: this.lvlIndex,
            points: this._gameplayController.points,
        };

        G.saveState.incrementCWinCount();

        // Mystery Gift clean up
        if (G.saveState.sessionData.mysteryGift.mysteryGiftModePeak) {
            const increase = G.saveState.mysteryGift_increaseStreak();
            configForPopUp.mysteryGiftStreakIncrease = increase;
        }
        G.saveState.mysteryGift_markLevelFinish();
        if (G.saveState.sessionData.mysteryGift.treasureHuntMode) {
            const collectedGems = treasureHuntMgr.completeLevel(this.lvlIndex);
            configForPopUp.treasureHunt = {
                collectedGems,
            };
        }

        // Level complete DDNA tracking
        if (this.lvlIndex === 0) {
            DDNA.tracking.ftuxEvent(5, 'firstLevelComplete');
            OMT.platformTracking.logFTUEvent('FTUFirstLevelComplete');
        } else if (this.lvlIndex === 1) {
            DDNA.tracking.ftuxEvent(9, 'secondLevelComplete');
        } else if (this.lvlIndex === 2) {
            DDNA.tracking.ftuxEvent(11, 'thirdLevelComplete');
        } else if (this.lvlIndex === 4) {
            DDNA.tracking.ftuxEvent(15, 'fifthLevelDone');
        } else if (this.lvlIndex === 5) {
            DDNA.tracking.ftuxEvent(16, 'sixthLevelDone');
        }
        // track last level won by the player
        if (DDNA.tracking.enabled) DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('lastLevelWon', this.mode === LevelType.CHALLENGE ? -1 : this.lvlData.levelNumber, true);

        // Pass scores for highscore user passing
        configForPopUp.globalScoreChange = {
            old: OMT.leaderboards.getYourTotalScore(),
            new: OMT.leaderboards.getYourTotalScore() + this._gameplayController.points,
        };

        // Continue to the win screen.
        const winFunc = () => { // Wrap it in a function because of fortune cookie
            this.handleWin(configForPopUp);
        };
        if (this.board.fortuneCookie && this.board.fortuneCookie.collected && !this.board.fortuneCookie.isSeen) {
            this.handleFortuneCookie(winFunc.bind(this));
        } else {
            winFunc();
        }
    }

    /**
     * Handles the win window. Various background flags are set while the win window is open
     * @param {Object} configForPopUp
     * @param {number} configForPopUp.lvlIndex
     * @param {number} configForPopUp.points
     * @param {boolean} configForPopUp.mysteryGiftStreakIncrease
     * @param {Object} configForPopUp.treasureHunt
     * @param {number} configForPopUp.treasureHunt.collectGems
     * @param {Object} configForPopUp.globalScoreChange
     * @param {number} configForPopUp.globalScoreChange.old
     * @param {number} configForPopUp.globalScoreChange.new
     */
    handleWin(configForPopUp) {
        this.windowMgr.pushWindow(['win', configForPopUp]);
        if (this._perLevelData) {
            //this.handleLeaderboards(this._gameplayController.points);
        }

        // Request help slowly ticks down to show... if it ever did
        if (OMT.feature.getFeatureRequestHelp()) {
            if (G.saveState.requestHelp_getTutorialAppearance() > 0) {
                let cur = G.saveState.requestHelp_getTutorialAppearance();
                cur = Math.max(0, cur - 1);
                if (cur === 0 && G.saveState.requestHelp_getTutorialComplete() < 10) {
                    G.saveState.requestHelp_setTutorialStep(0);
                }
                G.saveState.requestHelp_setTutorialReappearance(cur);
            }
        }

        // Number of levels to show until the friendship chest shows decrements
        if (OMT.feature.getFeatureFriendshipChest(false)) {
            G.saveState.friendshipChestDataManager.decrementNumberOfLevels(false);
        }
    }

    /**
     * Shows the leaderboard when the promise resolves.
     * @param {number} points
     */
    async handleLeaderboards(points) {
        const { stateInitCount } = this; // Needs to be a reference so it can check async-ness
        const passLevelResp = this._perLevelData.passLevel(points);
        const lvlNr = this._config.lvlIndex + 1;

        // Tournament
        OMT.platformLeaderboards.postTournamentScore(
            'totalStarsCollected', G.saveState.getAllStars(),
            G.saveState.getAllStars() - G.saveState.getStarsAtSessionStart(),
        );

        if (passLevelResp && passLevelResp.scoreImprovement) {
            // update level score
            let lvlID = parseInt(this.lvlData.id || lvlNr);
            if (this.mode === LevelType.CHALLENGE) {
                // TODO: figure out why we have to increment lvlID here.
                lvlID++;
                lvlID = lvlID.toString();
                lvlID += '_challenge';
            }
            try {
                await OMT.leaderboards.postScoreToLeaderboard('default', lvlID.toString(), points);
            } catch (error) {
                console.error(`level_${lvlNr} postScore`, error);
            }

            // update global score
            try {
                await OMT.leaderboards.postScoreToLeaderboard('default', 'default', OMT.leaderboards.getYourTotalScore() + points);
            } catch (error) {
                console.error('main leaderboard postScore', error);
            }

            // update map position
            try {
                await OMT.leaderboards.postScoreToLeaderboard(G.OMTsettings.global.leaderboardName, 'default', lvlNr);
            } catch (error) {
                console.error('completed levels leaderboard postScore', error);
            }
        }

        const isCorrectScene = game.state.getCurrentState() === this.state && stateInitCount === this.stateInitCount;
        if (!isCorrectScene) return; // we want to exit if the scene changed

        if (passLevelResp && passLevelResp.leaderboard) {
            if (lvlNr === 1 && G.firstTime) return;

            const currentUser = passLevelResp.leaderboard
                .find((user) => user.isCurrentUser);

            this.highscorePanel = new G.HighscorePanelIngame(); // Accessed externally
            this.highscorePanel.injectLevelData(passLevelResp.leaderboard, passLevelResp.passed);
            this.highscorePanel.makeVisible();

            if (passLevelResp.passed && passLevelResp.passed.length) {
                G.sb('pushWindow').dispatch([
                    'friendBeaten',
                    this.lvlIndex,
                    currentUser,
                    passLevelResp.passed[0],
                    passLevelResp.passed[1], // <-- It's fine if this is undefined
                    { x: 20, y: -70 },
                    this.highscorePanel,
                ]);
                OMT.notifications.scheduleGameTriggeredMessage(passLevelResp.passed[0].id, 'ScoreBeaten', 1, null, false);
            }
        }
    }

    /**
     * When the action queue is done
     */
    _onActionQueueEmpty() {
        // we need check if we have unsaved mission updates from the last move
        G.dailyMissionsMgr.checkUnsavedMissionProgress();

        // No moves? Trigger out of moves
        if (this._gameplayController.moves === 0) {
            if (!this._gameplayController.isGoalAchieved()) {
                this.outOfMoves();
            }
        }
    }

    /**
     * When out of moves
     */
    outOfMoves() {
        // imports
        const GemCounter = G.TreasureHunt.GameplayGemCounter;
        const { treasureHuntMgr } = G.TreasureHunt;

        // Increase helper 2.0 tracking
        if (!G.saveState.sessionData.levelsFailedSinceUsingHelper[this.lvlIndex]) G.saveState.sessionData.levelsFailedSinceUsingHelper[this.lvlIndex] = 1;
        else G.saveState.sessionData.levelsFailedSinceUsingHelper[this.lvlIndex]++;

        // Record failed level
        if (typeof G.saveState.data.failedCurrentLevel !== 'undefined' &&
            this.lvlIndex === G.saveState.data.failedCurrentLevel.level) {
            G.saveState.data.failedCurrentLevel.fails++;
        } else {
            G.saveState.data.failedCurrentLevel = {
                level: this.lvlIndex,
                fails: 1,
            };
        }

        // Show the pop up for out of moves
        if (G.IAP ||
            game.incentivised() ||
            G.saveState.getCoins() >= this._gameplayController.getPriceOfExtraMoves() * 2 ||
            G.saveState.isFreeMoneySpinAvailable()) {
            const configForPopUp = {};

            if (G.saveState.sessionData.mysteryGift.treasureHuntMode &&
                treasureHuntMgr.getLevelCollectedGems() > 0) {
                let shown = false;
                const reasonToShow = GemCounter.ReasonToShow;
                configForPopUp.position = { x: 0, y: -30 };
                configForPopUp.preCloseCallback = (() => {
                    if (!shown) {
                        shown = true;
                        this.treasureHuntGingyFail.show();
                        this.treasureHuntGemCounter.show(reasonToShow.OutOfMovesPopUp);
                        return false;
                    }
                    return true;
                });
                configForPopUp.closeCallback = (() => {
                    if (shown) {
                        this.treasureHuntGingyFail.hide();
                        this.treasureHuntGemCounter.hide(reasonToShow.OutOfMovesPopUp);
                    }
                });
            }

            configForPopUp.onResolveCallback = () => {
                // to indicate to the helpers that in this session, this level cant get helpers any more
                if (!G.levelsResolvedOOM) G.levelsResolvedOOM = {};
                G.levelsResolvedOOM[this.lvlIndex] = true;
            };

            this.windowMgr.pushWindow(['outOfMovesIAP', configForPopUp]);
        } else { // Or just show that they failed
            this.windowMgr.pushWindow('levelFailed');
        }
    }

    /**
     * Opens the fortune cookie window.
     * The fortune cookie window will fire a specific signal which this will
     * (hopefully in all cases) catch and then continue the flow of the win/lose functionality
     * @param {Function} returnFunc
     */
    async handleFortuneCookie(returnFunc) {
        G.sb('pushWindow').dispatch(['fortuneCookie', {
            playOpenAnim: true,
            hideNotNow: false,
            uiIcon: this.board.fortuneCookie.icon,
            coinReward: true,
        }]);
        this._signalBindings.push(G.sb('fortuneCookieWindowClose').addOnce(returnFunc));

        this.board.fortuneCookie.isSeen = true;
    }

    /**
     * Sets up the treasure hunt manager
     * @param {number} lvlIndex
     */
    setupTreasureHunt(lvlIndex) {
        // imports
        const { treasureHuntMgr } = G.TreasureHunt;
        const { GingyFailCharacter } = G.TreasureHunt;
        const { GameplayGemCounter } = G.TreasureHunt;

        treasureHuntMgr.startLevel(lvlIndex);
        const progress = treasureHuntMgr.getProgressData();
        this.treasureHuntGingyFail = new GingyFailCharacter();
        this.treasureHuntGemCounter = new GameplayGemCounter(
            0, progress.gemsTarget,
        );
        G.saveState.sessionData.mysteryGift.treasureHuntMode = true;
    }

    /**
     * When the chest is broken and the gift comes out
     * @param {any} chest
     * @param {any} giftData
     */
    onChestGiftShown(chest, giftData) {
        // imports
        const { treasureHuntMgr } = G.TreasureHunt;
        const GemCounter = G.TreasureHunt.GameplayGemCounter;
        const { uiTargetParticles } = this;

        // Chest is a treasure hunt chest
        if (giftData[0] === TreasureChestTypes.TREASURE_HUNT) {
            const gemCounter = this.treasureHuntGemCounter;
            if (!gemCounter) return;

            const giftObj = chest.getGiftObject();
            const targetObj = gemCounter.getTargetObject();
            const invites = treasureHuntMgr.getInvitedContexts().length;
            // eslint-disable-next-line arrow-body-style
            const animateGemToCounter = async(startObj, endObj) => {
                return new Promise((resolve, reject) => {
                    const part = uiTargetParticles.init(
                        game.world.bounds.x + startObj.worldPosition.x,
                        startObj.worldPosition.y,
                        'gem5_small',
                        endObj,
                    );
                    part.scale.setTo(startObj.worldScale.x);
                    part.rotation = startObj.worldRotation;
                    part.vel.setTo(
                        game.rnd.realInRange(-4, 4),
                        game.rnd.realInRange(-4, 4),
                    );

                    part.onStart.addOnce(() => {
                        game.add.tween(part.scale)
                            .to({ x: 0.7, y: 0.7 }, 400, Phaser.Easing.Sinusoidal.In, true);
                    });

                    part.onFinish.addOnce(() => {
                        resolve();
                    });

                    part.start();
                });
            };

            for (let i = 0; i < invites + 1; i++) {
                gemCounter.show(GemCounter.ReasonToShow.Gem);
                animateGemToCounter(giftObj, targetObj)
                    .then(() => {
                        G.sfx.pop.play();
                        treasureHuntMgr.collectGem();
                        gemCounter.increaseAmount();
                        gemCounter.hide(GemCounter.ReasonToShow.Gem);
                    });
            }
        } else { // Chest was a regular chest
            const coins = giftData[0] === 'coin' ? parseInt(giftData[1]) : 0;
            G.gift.applyGift(giftData);
            if (coins > 0) {
                DDNA.transactionHelper.queueLevelCoinReward(coins, 'GameplayChest');
                G.sb('coinsFromGameplayChest').dispatch(giftData[1]);
            }
        }
    }

    /**
     * Locks the input on the settings menu and booster panel
     */
    lockInput() {
        this.settingsMenu.lockInput();
        this.boosterPanel.lockInput();
    }

    /**
     * Unlocks the input on the setting menu and booster panel
     */
    unlockInput() {
        this.settingsMenu.unlockInput();
        this.boosterPanel.unlockInput();
    }

    /**
     * Initializes debug mode. Also known as the screen you see when you enter a level
     * through the level editor
     */
    debugInit() {
        if (!this._debugMode) { return; }
        this.initDebugTools();

        const levelNr = new G.Text(0, 0, `LEVEL ${this.lvlIndex + 1}`, {
            style: 'font-white',
            fontSize: '30px',
        });
        game.add.existing(levelNr);

        const mapBtn = new G.Text(250, 0, 'MAP', {
            style: 'font-white',
            fontSize: '30px',
        });
        mapBtn.inputEnabled = true;
        mapBtn.input.useHandCursor = true;
        mapBtn.events.onInputDown.add(() => {
            game.state.start('EditorWorld', true, false, this._gameplayController.lvlIndex);
        }, this);
        game.add.existing(mapBtn);

        const editBtn = new G.Text(350, 0, 'LVL EDIT', {
            style: 'font-white',
            fontSize: '30px',
        });
        editBtn.inputEnabled = true;
        editBtn.input.useHandCursor = true;
        editBtn.events.onInputDown.add(() => {
            game.state.start('Editor', true, false, G.Helpers.levelDataMgr.getLevelByIndex(this.lvlIndex).id);
        }, this);
        game.add.existing(editBtn);

        const prevBtn = new G.Text(500, 0, 'PREV', {
            style: 'font-white',
            fontSize: '30px',
        });
        prevBtn.inputEnabled = true;
        prevBtn.input.useHandCursor = true;
        prevBtn.events.onInputDown.add(() => {
            console.log(`current: ${this._gameplayController.lvlIndex}`);
            console.log(`prev: ${Math.max(0, this.lvlIndex - 1)}`);
            // FIXME: the arguments are not valid
            const levelData = {
                lvlIndex: Math.max(0, this.lvlIndex - 1),
                debugMode: true,
            };
            game.state.start('Game', true, false, levelData); // Math.max(0,this.lvlIndex-1),true);
        }, this);
        game.add.existing(prevBtn);

        const nextBtn = new G.Text(600, 0, 'NEXT', {
            style: 'font-white',
            fontSize: '30px',
        });
        nextBtn.inputEnabled = true;
        nextBtn.input.useHandCursor = true;
        nextBtn.events.onInputDown.add(() => {
            console.log(`current: ${this._gameplayController.lvlIndex}`);
            console.log(`nextL ${Math.min(G.Helpers.levelDataMgr.getMaxLevelIndex(), this.lvlIndex + 1)}`);
            // FIXME: the arguments are not valid
            const levelData = {
                lvlIndex: Math.min(G.Helpers.levelDataMgr.getMaxLevelIndex(), this.lvlIndex + 1),
                debugMode: true,
            };
            game.state.start('Game', true, false, levelData); // Math.min(G.Helpers.levelDataMgr.getMaxLevelIndex(),this.lvlIndex+1),true);
        }, this);
        game.add.existing(nextBtn);
    }

    /**
     * Initializes the debug tools.
     */
    initDebugTools() {
        this.bot = new G.BOT(this.board);
        const keys = game.input.keyboard.addKeys({
            one: Phaser.Keyboard.ONE,
            two: Phaser.Keyboard.TWO,
            three: Phaser.Keyboard.THREE,
            four: Phaser.Keyboard.FOUR,
            five: Phaser.Keyboard.FIVE,
            six: Phaser.Keyboard.SIX,
            r: Phaser.Keyboard.R,
        });

        keys.one.onDown.add(() => {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
            s.board.getCandy(this._dbgPos[0], this._dbgPos[1]).changeInto('1');
        }, this);
        keys.two.onDown.add(() => {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
            s.board.getCandy(this._dbgPos[0], this._dbgPos[1]).changeInto('2');
        }, this);
        keys.three.onDown.add(() => {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
            s.board.getCandy(this._dbgPos[0], this._dbgPos[1]).changeInto('3');
        }, this);
        keys.four.onDown.add(() => {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
            s.board.getCandy(this._dbgPos[0], this._dbgPos[1]).changeInto('4');
        }, this);
        keys.five.onDown.add(() => {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
            s.board.getCandy(this._dbgPos[0], this._dbgPos[1]).changeInto('5');
        }, this);
        keys.six.onDown.add(() => {
            this._dbgPos = this.board.inputController.pointerToCell(game.input.activePointer);
            s.board.getCandy(this._dbgPos[0], this._dbgPos[1]).changeInto('6');
        }, this);
    }
}

G.Game = Game;